import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FP610 / FP611)
// ============================================================

export interface FP610 {
  fp610_01: string;         // 單號 PK
  fp610_10: string;         // S/C NO
  fp610_11: string | null;  // 日期
  fp610_12: string;
  fp610_13: string;         // SHIPPING MARK
  fp610_14: string;         // DESCRIPTION OF GOODS
  fp610_141: string;        // 原始DESCRIPTION備份
  fp610_15: string;         // 材積
  fp610_16: number;         // 總項數
  fp610_17: number;         // 總碼數
  fp610_18: number;         // 總米數(MTS)
  fp610_19: number;         // 總重量(G.W.)
  fp610_20: number;         // 總淨量(N.W.)
  fp610_21: number;         // 包裝單位 (1=R/NO. 2=B/NO. 3=C/NO.)
  fp610_22: number;         // MTS換算率
  fp610_23: number;         // 布重換算率(G.W.計算用)
  fp610_24: number;
  fp610_25: string;         // 客戶代號
  fp610_26: number;         // 內外銷別 (1=外銷)
  fp610_27: number;         // 出貨單位 (1=YDS, 2=MTS, 3=PCS)
  fp610_28: number;         // 針織/平織 (1=平織, 2=針織)
  fp610_29: string;         // 產品代號
  fp610_31: string;         // A/C NO.
  fp610_32: string;         // G.U.P/O #
  fp610_33: string;         // PROJECT REF.
  fp610_91: string;         // 建立者
  fp610_92: string | null;  // 建立日期
  fp610_93: string;         // 修改者

  // Associations
  details?: FP611[];
}

export interface FP611 {
  fp611_01: string;   // 單號 FK
  fp611_02: number;   // 項次
  fp611_11: string;   // R/NO
  fp611_12: string;   // COLOR
  fp611_121: string;  // 原始COLOR備份
  fp611_21: number;   // 碼數1
  fp611_22: number;   // 碼數2
  fp611_23: number;   // 碼數3
  fp611_24: number;   // 碼數4
  fp611_31: string;   // 缸號1
  fp611_32: string;   // 缸號2
  fp611_33: string;   // 缸號3
  fp611_34: string;   // 缸號4
  fp611_41: number;   // 合計碼數(YDS)
  fp611_42: number;   // MTS
  fp611_43: number;   // G.W.
  fp611_44: number;   // N.W.
  fp611_91: string;
  fp611_92: string | null;
  fp611_93: string;
  fp611_421: number;
  fp611_431: number;
  fp611_441: number;
  fp611_442: number;  // 毛重變量
  fp611_51: number;   // 補碼數1
  fp611_52: number;   // 補碼數2
  fp611_53: number;   // 補碼數3
  fp611_54: number;   // 補碼數4
}

// ============================================================
// Request / Response types
// ============================================================

export interface P251ListResponse {
  data: FP610[];
  total: number;
  page: number;
  size: number;
}

export interface P251CreateRequest {
  master: Partial<FP610>;
  details: Partial<FP611>[];
}

// ============================================================
// API methods
// ============================================================

export const p251Api = {
  async list(page = 1, size = 20): Promise<P251ListResponse> {
    const res = await apiClient.get('/api/pwp251', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FP610> {
    const res = await apiClient.get(`/api/pwp251/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: P251CreateRequest): Promise<FP610> {
    const res = await apiClient.post('/api/pwp251', data);
    return res.data;
  },

  async update(id: string, data: P251CreateRequest): Promise<FP610> {
    const res = await apiClient.put(`/api/pwp251/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/pwp251/${encodeURIComponent(id)}`);
  },
};
